module.exports = __webpack_public_path__ + "img/clos-menu.91567fac.svg";